import { appTheme as appThemes } from '@pata-app/themes';

const colors = {
  black: '#000000',
  white: '#FFFFFF',

  // Alerts
  error: '#D32F2F',
  info: '#0074e6',
  lightBlue: '#e5f2ff',
  lightGreen: '#eaf6ed',
  orange: '#f57f17',
  success: '#2e7b32',
  successAlt: '#00a33c',
  warning: '#fdd835',

  // Greyscale
  darkGrey: '#2e2d2c',
  grey: '#706f6f',
  lightGrey: '#f7f8f8',
  lighterGrey: '#f7f8f8',
  mediumGrey: '#d8d8d8',

  // Pata Colours
  pataBlue: '#117191',
  pataGreen: '#8cc4b8',
  pataDarkGreen: '#25948f',
  pataTeal: '#90cfd1',
  pataOrange: '#f5a046',
  pataYellow: '#f5c14f',
};

const breakpontSizes = {
  s: 640,
  m: 768,
  l: 1024,
  xl: 1280,
  xxl: 1600,
  xxxl: 1984,
};

const fontSizes = {
  xxs: 8,
  xs: 10,
  s: 12,
  sm: 14,
  m: 16,
  ml: 18,
  l: 20,
  xl: 24,
  xxl: 26,
  xxxl: 28,
  xxxxl: 32,
};

const fontWeight = {
  regular: 300,
  semiBold: 600,
  bold: 700,
};

const fontFamily = {
  light: 'SourceSansPro, sans-serif',
  regular: 'SourceSansPro, sans-serif',
  semiBold: 'Jost, sans-serif',
  bold: 'SourceSansPro, sans-serif',
};

export const appTheme = {
  ...appThemes,
  colors: {
    primary: {
      blue: colors.pataBlue,
      green: colors.pataDarkGreen,
      teal: colors.pataTeal,
    },
    secondary: {
      orange: colors.pataOrange,
      yellow: colors.pataYellow,
      green: colors.pataGreen,
    },
    greyscale: {
      white: colors.white,
      lighter: colors.lighterGrey,
      light: colors.lightGrey,
      medium: colors.mediumGrey,
      dark: colors.grey,
      darker: colors.darkGrey,
      black: colors.black,
    },
    info: {
      light: colors.lightBlue,
      medium: colors.info,
    },
    success: {
      light: colors.lightGreen,
      medium: colors.successAlt,
      dark: colors.success,
    },
    warning: {
      medium: colors.warning,
      dark: colors.orange,
    },
    danger: {
      medium: colors.error,
    },
  },
  breakpontSizes,
  breakpoints: {
    xs: `(min-width: ${breakpontSizes.s}px)`,
    s: `(min-width: ${breakpontSizes.s}px)`,
    m: `(min-width: ${breakpontSizes.m}px)`,
    l: `(min-width: ${breakpontSizes.l}px)`,
    xl: `(min-width: ${breakpontSizes.xl}px)`,
    xxl: `(min-width: ${breakpontSizes.xxl}px)`,
    xxxl: `(min-width: ${breakpontSizes.xxxl}px)`,
  },
  fontSizes,
  fontFamily,
  fontWeight,
  sizing: [4, 8, 16, 20, 24, 32, 40],
  border: {
    container: {
      weight: 1,
      radius: 10,
      style: 'solid',
    },
    element: {
      weight: 1,
      radius: 2,
      style: 'solid',
    },
  },
};

export type TAppTheme = typeof appTheme;
